(ns frontend.state.association
  (:require [common.schema.associations :as associations]
            [frontend.state.current-session :as session]))

(defn resolve-related-entities-by-group [entity target-type]
  (let [entity-type (:entity/type entity)
        entity-id (:db/id entity)
        related-entities (:common/related-entities entity)
        association-type-schema (some-> associations/schema
                                        (get entity-type)
                                        (get target-type))
        related-groups (->> related-entities
                            (map (fn [id]
                                   (get @session/entities id)))
                            (filter (fn [a]
                                      (let [source-id (:entity-association/source-entity a)
                                            source (get @session/entities source-id)
                                            s-type (:entity/type source)
                                            target-id (:entity-association/target-entity a)
                                            target (get @session/entities target-id)
                                            t-type (:entity/type target)]
                                        (or (and (= s-type target-type)
                                                 (not= source-id entity-id))
                                            (and (= t-type target-type)
                                                 (not= target-id entity-id))))))
                            (group-by (fn [a]
                                        (let [association-type (:entity-association/type a)
                                              association-type-schema (get association-type-schema association-type)]
                                          (if (:association/uni-directional? association-type-schema)
                                            (if (= (:entity-association/source-entity a) entity-id)
                                              (:association/source-direction association-type-schema)
                                              (:association/target-direction association-type-schema))
                                            association-type))))
                            (sort-by (fn [[type _]]
                                       (let [t (get association-type-schema type)
                                             ord (:common/ord t)]
                                         ord))))]
    related-groups))
